<template>
  <div
    class="row items-center justify-between no-wrap"
  >
    <div class="q-mr-md drink-name">
      {{ drink.name }}
    </div>
    <div class="row no-wrap items-center">
      <DrinkTrendChip :difference="drink.difference"/>
      <div class="text-weight-bold q-ml-sm">
        <div>{{ (drink.optimized_price).toFixed(2) }}€</div>
      </div>
    </div>
  </div>
</template>
<script>
import DrinkTrendChip from '../components/DrinkTrendChip';

export default {
  name: "DrinkVisu",
  components: {
    DrinkTrendChip
  },
  props: {
    drink: Object,
  },
}
</script>
<style>
.drink-name {
  font-size: 20px;
}
</style>
